import { render, staticRenderFns } from "./Hero2.vue?vue&type=template&id=7a0561e5&scoped=true&"
var script = {}
import style0 from "./Hero2.vue?vue&type=style&index=0&id=7a0561e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0561e5",
  null
  
)

export default component.exports